'use strict';

/* eslint-disable @typescript-eslint/no-var-requires */

// True when value is the QrScanner constructor (has static setWorkerUrl).
function isQrScannerClass(value) {
  return typeof value === 'function' && typeof value.setWorkerUrl === 'function';
}

// Reads `default` from tsup CJS bundles where it is often a getter, not a data property.
function readDefaultExport(target) {
  if (!target || (typeof target !== 'object' && typeof target !== 'function')) {
    return undefined;
  }

  var desc = Object.getOwnPropertyDescriptor(target, 'default');

  if (desc && desc.get) {
    try {
      return desc.get.call(target);
    } catch (e) {
      return undefined;
    }
  }

  if (Object.prototype.hasOwnProperty.call(target, 'default')) {
    return target.default;
  }

  return undefined;
}

// Unwraps webpack __webpack_require__.n() and nested default export wrappers.
function resolveQrScannerFromModule(root) {
  var visited = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var queue = [root];

  while (queue.length > 0) {
    var current = queue.shift();

    if (current === null || current === undefined) {
      continue;
    }

    if (isQrScannerClass(current)) {
      return current;
    }

    if (typeof current === 'function' && !isQrScannerClass(current)) {
      try {
        var invoked = current();
        if (invoked !== undefined && invoked !== current) {
          queue.unshift(invoked);
        }
      } catch (e) {
        // Not a webpack .n interop getter — ignore.
      }
    }

    if (typeof current !== 'object' && typeof current !== 'function') {
      continue;
    }

    if (visited && typeof current === 'object' && visited.has(current)) {
      continue;
    }

    if (visited && typeof current === 'object') {
      visited.add(current);
    }

    var lazyDefault = readDefaultExport(current);

    if (lazyDefault !== undefined && lazyDefault !== current) {
      queue.unshift(lazyDefault);
    }

    var keys = Object.keys(current);

    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var value = current[key];

      if (isQrScannerClass(value)) {
        return value;
      }

      if (value !== undefined && typeof value === 'function') {
        queue.push(value);
      }

      if (value !== null && typeof value === 'object') {
        queue.push(value);
      }
    }
  }

  return null;
}

var scannerModule = require('@agicash/qr-scanner/dist/index.cjs');
var QrScannerClass = resolveQrScannerFromModule(scannerModule);

if (!QrScannerClass) {
  var topKeys =
    scannerModule && (typeof scannerModule === 'object' || typeof scannerModule === 'function')
      ? Object.keys(scannerModule).join(', ')
      : String(typeof scannerModule);

  throw new Error('Failed to load @agicash/qr-scanner QrScanner class (top keys: ' + topKeys + ')');
}

module.exports = QrScannerClass;
module.exports.default = QrScannerClass;
